export default "__VITE_ASSET__1bee320a__"